<template>
  <div>
    <div class="container">
      <TextArea
        class="child"
        :textTitle="endpointName"
        :textLinesArray="endpointDesc"
      ></TextArea>
      <EndpointCard
        class="child"
        cardTitle="ENDPOINTS"
        :endpoints="endpoints"
      />
      <TextArea
        class="child"
        :textTitle="filteringTitle"
        :textLinesArray="filteringText"
      ></TextArea>
    </div>
    <div class="container">
      <Attribute
        class="child"
        :attributes="attributes"
        :endpoint="responseTitle"
      />
      <ResponseCard
      class="child"
      :response="response"
      :cardTitle="responseCodeTitle"
      />
    </div>
  </div>
</template>
<script>
import EndpointCard from "../../../components/content/EndpointCard.vue";
import Attribute from "../../../components/request/Attribute.vue";
import TextArea from "../../../components/content/TextArea.vue";
import ResponseCard from "../../../components/request/ResponseCard.vue";

export default {
  components: {
    EndpointCard,
    Attribute,
    TextArea,
    ResponseCard,
  },
  computed: {
    endpointName() {
      return this.$t("financialPostsV4.endpointTitle");
    },
    endpointDesc() {
      return this.$t("financialPostsV4.endpointDesc");
    },
    endpoints() {
      return this.$t("financialPostsV4.controllerEndpoints");
    },
        filteringTitle() {
      return this.$t("financialPostsV4.filteringTitle");
    },
    filteringText() {
      return this.$t("financialPostsV4.filteringText");
    },
    attributes() {
      return this.$t("financialPostsV4.getAttributes");
    },
    responseTitle() {
      return this.$t("financialPostsV4.getTitle");
    },
    response() {
      return this.$t("financialPostsV4.getResponse");
    },
    responseCodeTitle() {
      return this.$t("financialPostsV4.responseCodeTitle");
    },
  },
};
</script>
<style scoped>
  .container {
    display: flex;
    flex-flow: row wrap;
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .child {
    min-width: 40%;
    max-width: 45%;
    flex-grow: 1;
    flex-shrink: 1;
  }

  @media screen and (max-width: 500px) {
    .container {
      flex-flow: column wrap;
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }

  @media screen and (max-width: 500px) {
    .child {
      max-width: 380px;
      min-width: 300px;
    }
  }
</style>